export default __webpack_public_path__ + "static/media/appointment.f46084d1.svg";